var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"100%","height":"100%","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10 1H6V6L1 6V10H6V15H10V10H15V6L10 6V1Z","fill":_vm.color}})])}
var staticRenderFns = []

export { render, staticRenderFns }